module.exports = __webpack_public_path__ + "img/datepicker.1b26a334.svg";